import { CompanyRef } from './company.model';
import { DeductionTypeRef } from './deduction-type.model';
import { ExpenseFamilyTypeRef } from './expense-family-type.model';
import { InvoicePPRTypeRef } from './invoice-ppr-type.model';
import { ReferentialModel } from './referential.model';
import { VatRef } from './vat.model';

export class ReferentialsModel {
  constructor(
    public AssetTypes: ReferentialModel[],
    public GroupTypes: ReferentialModel[],
    public ProfessionTypes: ReferentialModel[],
    public RecyclingFlags: ReferentialModel[],
    public WaitingFlags: ReferentialModel[],
    public RejectionFlags: ReferentialModel[],
    public EmailTemplateTypes: ReferentialModel[],
    public VatRefs: VatRef[],
    public ExpenseFamilyTypes: ExpenseFamilyTypeRef[],
    public InvoicePPRType: InvoicePPRTypeRef[],
    public DeductionType: DeductionTypeRef[],
    public TypologieType: ReferentialModel[],
    public Company: CompanyRef[],
    public TreeLevelType: ReferentialModel[],
    public ExpenseTradeTypes: ReferentialModel[],
  ) {}
}
